
















import Vue from 'vue';
import { validatorInArray } from 'src/utils/string';

type Step = 'INFO' | 'PHOTO' | 'PREVIEW' | 'SAVE';
const steps: Step[] = ['INFO', 'PHOTO', 'PREVIEW', 'SAVE'];

export default Vue.extend({
  props: {
    step: {
      type: String,
      required: true,
      validator: validatorInArray(steps),
    },
  },
  computed: {
    progressItems: () => [
      {
        num: 1,
        text: '基本情報',
        step: 'INFO',
      },
      {
        num: 2,
        text: '証明写真',
        step: 'PHOTO',
      },
      {
        num: 3,
        text: 'プレビュー',
        step: 'PREVIEW',
      },
      {
        num: 4,
        text: '保存',
        step: 'SAVE',
      },
    ],
  },
  methods: {
    progressClass(step: Step): string[] {
      const r: string[] = [];

      if (this.step === step) r.push('-active');

      const propStepIndex = steps.findIndex(s => s === this.step);
      const currentStepIndex = steps.findIndex(s => s === step);
      if (propStepIndex > currentStepIndex) r.push('-finished');

      return r;
    },
  },
});
